import { Heading } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import useStyles from '../styles'
import { Settings } from '../types'
import LanguageSelector from './LanguageSelector'

interface LanguageSelectProps {
  settings?: Settings
  updateSettings?: (settings: Partial<Settings>) => void
  isLoading: boolean
}

const LanguageSelect = ({
  settings,
  updateSettings,
  isLoading,
}: LanguageSelectProps) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <>
      <Heading headingLevel="1" headingLevelStyle="3">
        {t('Interface language')}
      </Heading>

      <div className={classes.select}>
        <LanguageSelector
          settings={settings}
          updateSettings={updateSettings}
          isLoading={isLoading}
        />
      </div>
    </>
  )
}

export default LanguageSelect
